<template>
  <div id="Main" class="pageContainer">
    <div class="login">
      <login-page></login-page>
    </div>
    <div class="nav">
      <nav-page></nav-page>
    </div>
    <div class="content">
      <!-- 内容部分 -->
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import LoginPage from "./Login";
import NavPage from "./NavPage";

export default {
  data() {
    return {};
  },
  components: {
    LoginPage,
    NavPage,
  }
};
</script>

<style lang="less" scoped>
#Main {
  display: flex;
  flex-direction: column;
  .login {
    height: 40px;
  }
  .nav {
    height: 44px;
    margin-top: 10px;
  }
  .content {
    flex: 1;
    overflow-y: auto;
    background-color: #f0f0f0;
  }
}
</style>
